export const calculateAverageDuration = (tests) => {
    return calculateTotalDuration(tests) / tests.length;
  }

export const calculateTotalDuration = (tests) => {
    var totalTimer = 0;
    tests.forEach((test) =>{
      totalTimer += test.duration;
    });
    return totalTimer;
  }

export const calculateAverageEntries = (tests) => {
    var totalEntries = 0;
    tests.forEach((test) =>{
      totalEntries += test.targetEntries;
    });
    return totalEntries / tests.length;
  }

  export const calculateAverageClicks = (tests) => {
    var totalClicks = 0;
    tests.forEach((test) =>{
      totalClicks += test.clicks;
    });
    return totalClicks / tests.length;
  }

export const calculateClickAccuracy = (tests) => {
    var totalClicks = 0;
    tests.forEach((test) =>{
      totalClicks += test.clicks;
    });
    return (tests.length / totalClicks) * 100;
  }

  export const calculateTargetAccuracy = (tests) => {
    var correctTargets = 0;
    tests.forEach((test) =>{
      correctTargets += test.clicks === 1 ? 1: 0;
    });
    return (correctTargets / tests.length) * 100;
  }

export const calculateTargetsPerMinute = (tests) => {
  return tests.length/(calculateTotalDuration(tests) / 60000);
}